<template>
    <div>
        <b-modal
            id="error"
            hideFooter
            headerCloseContent=""
            :hideHeader="isHeaderHidden"
            centered
            :contentClass="{ 'custom-error': isCustomError }"
        >
            <template slot="modal-title">
                {{ title }}
            </template>
            <div
                class="d-block text-center"
            >
                <p v-html="errorText" />
            </div>
            <div class="d-block text-right">
                <v-button
                    variant="success"
                    @click="$bvModal.hide('error')"
                >
                    {{ buttonText }}
                </v-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import errors from '@/texts/errors';
import { ERROR_CODES } from '@/helpers/constants';
import VButton from '@/components/ui/VButton';

/** @typedef {{
 * message?: string,
 * buttonText?: string,
 * isHeaderHidden?: boolean
 * }} ErrorParams
 */

export default {
    name: 'ExceptionModal',

    components: {
        VButton,
    },

    inject: ['logout'],

    data() {
        return {
            title: '',
            errorText: '',
            isHeaderHidden: false,
            buttonText: '',
            isFailedToUpdateTheStamps: false,
            customError: false,
        };
    },

    computed: {
        needHideTitle() {
            return this.isHideTitle || this.isFailedToUpdateTheStamps;
        },

        isCustomError() {
            return this.isFailedToUpdateTheStamps || this.customError;
        },
    },

    methods: {
        showError: function(code, addHelpInfo = true, title = null) {
            this.isFailedToUpdateTheStamps = code === ERROR_CODES.failedToUpdateTheStamps;

            this.title = title || this.$t('main.exception.title');

            this.buttonText = this.isFailedToUpdateTheStamps ? this.$t('main.exception.ok') : this.$t('main.exception.button');

            if (code) {
                const errorTranslateKey = errors[code];

                if (errorTranslateKey) {
                    this.errorText = this.$i18n.t(errorTranslateKey);
                } else {
                    this.errorText = code;
                }
            }

            this.errorText += addHelpInfo ? `, ${this.$i18n.t(errors.helpInfo)}` : '';
            this.$bvModal.show('error');
        },

        /** @param {ErrorParams} params */
        showCustomError(params) {
            this.errorText = params.message || this.$t('default');
            this.buttonText = params.buttonText || this.$t('main.exception.button');
            this.isHeaderHidden = params.isHeaderHidden || false;
            this.title = params.title || this.$t('main.exception.title');

            this.$bvModal.show('error');
        },

        onShowError(code = 'default', addHelpInfo = true, title = null, params = {}) {
            this.errorText = '';

            if (Object.keys(params).length) {
                this.customError = true;
                this.showCustomError(params);
            } else {
                this.showError(code, addHelpInfo, title);
            }
        },
    },

    mounted() {
        this.$root.$on(
            'showError',
            this.onShowError,
        );
    },

    beforeDestroy() {
        this.$root.$off('showError', this.onShowError);
    },
};
</script>

<style lang='scss' scoped>
::v-deep {
    .custom-error {
        .text-center {
            font-size: 18px;
            font-weight: 600;
        }

        p {
            margin-bottom: 20px;
        }

        @media (min-width: 768px) {
            padding: 0;

            .modal-body {
                padding: 26px;
            }
        }
    }
}
</style>